import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Signup is now handled through social login on the Login page
const Signup = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/login');
  }, [navigate]);

  return null;
};

export default Signup;
